import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import axios from "axios";
import store from "./store";

import "../src/assets/styles/styles.scss";
import VueClipboard from "vue-clipboard2";
import VueFullscreen from "vue-fullscreen";
import moment from "moment";
import { Paddle } from "./Paddle";
import { initializeApp } from "firebase/app";
import {BrowserTracing} from "@sentry/tracing";
import * as Sentry from "@sentry/vue";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyABhMOrZ3GB-41dm9Yep7XUSGdSednl2-o",
  authDomain: "getsynced-development-0.firebaseapp.com",
  projectId: "getsynced-development-0",
  storageBucket: "getsynced-development-0.appspot.com",
  messagingSenderId: "315717414268",
  appId: "1:315717414268:web:d23f6bcbe1b4f691adc8f9",
};

if(process.env.NODE_ENV === "production") {
  Sentry.init({
    Vue,
    dsn: "https://4d95614398e5481195c3351777c34604@o481633.ingest.sentry.io/4504542124572672",
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: ["localhost", "test.getsynced.io", /^\//],
      }),
      new Sentry.Replay()
    ],
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

  });
}

// Initialize Firebase
initializeApp(firebaseConfig);

navigator.getUserMedia =
  navigator.getUserMedia ||
  navigator.webkitGetUserMedia ||
  navigator.mozGetUserMedia ||
  navigator.msGetUserMedia;

Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

// Access to the store from the browser console. TODO: Remove this when done testing
if (process.env.NODE_ENV !== "production") {
  window.__VueStore__ = store;
}

Vue.use(VueFullscreen);
Vue.use(VueClipboard);

Vue.use(Paddle, {
  vendor: 3192,
  sandbox: process.env.NODE_ENV !== "production",
});

new Vue({
  router,
  axios,
  store,
  render: (h) => h(App),
}).$mount("#app");
